import { clearAllConversationStarters } from '../../../shared/lib/conversationStarter/ConversationStarterStorage';
import * as jstBroadcast from '../../../shared/native-modules/tare/jstBroadcast';

import { useEffect } from 'react';
import { Platform } from 'react-native';

/**
 * Keeps the Ask Career Scout starter -> conversation mapping short-lived:
 *
 *  - Clears the in-memory mapping when the host component unmounts. Mounted
 *    by `AppVJLoadedContent`, so this fires when the user leaves the View
 *    Job screen.
 *  - Clears the mapping on logout via the `UserDidLogout` broadcast. The
 *    broadcast is iOS-only today (see `useMessagingLogoutCleanup`); on
 *    Android, the screen-unmount cleanup is the primary safeguard.
 */
export function useConversationStarterCleanup(): void {
    useEffect(() => {
        let subscription: jstBroadcast.JstBroadcastSubscription | null = null;

        if (Platform.OS === 'ios') {
            void jstBroadcast
                .subscribe('UserDidLogout', () => {
                    clearAllConversationStarters();
                })
                .then((sub) => {
                    subscription = sub;
                });
        }

        return () => {
            void subscription?.remove();
            clearAllConversationStarters();
        };
    }, []);
}
